'use client';

import { ArtworkType } from '@vimond/theme/artwork';
import { addParamsToImageURL } from '@vimond/utils/ui/addParamsToImageURL';
import Image, { ImageProps } from 'next/image';
import { useRef, useState } from 'react';

type Props = ImageProps & {
  src: string;
  alt?: string;
  fallbackToDefault?: boolean;
  height?: number;
  location?: ArtworkType;
  onLoadError?: () => void;
  title?: string;
  width?: number;
};

export const Artwork = (props: Props) => {
  const {
    alt,
    fallbackToDefault,
    height,
    location = 'main',
    onLoadError,
    src,
    title,
    width,
    ...rest
  } = props;
  const [imgSrc, setImgSrc] = useState(
    src ? addParamsToImageURL({ source: src, location }) : '',
  );
  const imageWrapperRef = useRef<HTMLDivElement>(null);

  const handleImageLoadError = () => {
    // If no fallback or already tried fallback, hide the wrapper
    if (!fallbackToDefault || imgSrc === src) {
      if (imageWrapperRef.current) {
        imageWrapperRef.current.className = 'hidden';
      }
      onLoadError?.();
      return;
    }
    setImgSrc(src);
  };

  // Don't render Image if src is empty or imgSrc is empty
  // This prevents Next.js ImagePreload error with empty href
  if (!src || !imgSrc) {
    return null;
  }

  return (
    <div ref={imageWrapperRef} className="contents">
      <Image
        {...rest}
        title={title ?? alt}
        alt={alt}
        src={imgSrc}
        width={width}
        height={height}
        onError={handleImageLoadError}
      />
    </div>
  );
};
